import { MouseEvent, useState } from 'react';
import { Logout } from '@mui/icons-material';
import { IconButton, ListItemIcon, Menu, MenuItem, Stack } from '@mui/material';
import Avatar from './Avatar';
import { useKeycloak } from '@react-keycloak/web';

const AccountMenu = (props: any) => {
    const { keycloak } = useKeycloak()
    const { onLogout } = props;
    const user = keycloak?.tokenParsed?.email || ""
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Stack direction="row" spacing={1} alignItems="center" paddingX={'3px'} sx={{
                borderRadius: '40px',
                minWidth: '2rem'
            }}>
                <IconButton sx={{ padding: 0 }} onClick={handleClick}>
                    <Avatar name={user?.split('@')[0] || null} />
                </IconButton>
            </Stack>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                // onClick={handleClose}
                sx={{ paddingY: 0 }}
                PaperProps={{
                    square: true,
                    elevation: 0,

                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        borderRadius: 0,
                        minWidth: '12rem',
                        mt: 0.5
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >

                <MenuItem onClick={onLogout} sx={{ color: '#f00' }}>
                    <ListItemIcon>
                        <Logout color="error" fontSize="small" />
                    </ListItemIcon>
                    Logout
                </MenuItem>
            </Menu>


        </>
    )
}

export default AccountMenu;
